import { AgentEndpoints, RequestMethods, useRequest } from '@shared/index';
import type { CommonResponse } from '@shared/types';

import type { GetMVPProfileResponse } from './get-mvp-profile.types';

export const useGetMVPProfile = () => {
  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    never,
    GetMVPProfileResponse,
    CommonResponse
  >({
    params: {
      key: 'getMVPProfile',
      method: RequestMethods.GET,
      url: `${AgentEndpoints.AGENTS}/agent-mvp-profile-data`,
      fetchManual: true,
    },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
